import React from 'react';
import AgingReportPage from './AgingReportPage';

export default function ARAgingReportPage() {
  return <AgingReportPage variant="ar" />;
}
